import { render } from "./PaymentLink.vue?vue&type=template&id=635adcac"
import script from "./PaymentLink.vue?vue&type=script&lang=js"
export * from "./PaymentLink.vue?vue&type=script&lang=js"
script.render = render

export default script